export const IMPORT_SAMPLE_SO = [
    {
      "accountid": "AC00001",
      "salesno": "SO0000001",
      "item": "Item A",
      "qty": 1,
      "action": "Add",
    },
    {
        "accountid": "AC00001",
        "salesno": "SO0000001",
        "item": "Item A2",
        "qty": 2,
        "action": "Add",
    },
    {
        "accountid": "AC00002",
        "salesno": "SO0000002",
        "item": "Item B",
        "qty": 3,
        "action": "Update",
      },
      {
        "accountid": "AC00003",
        "salesno": "SO0000003",
        "item": "Item C",
        "qty": 2,
        "action": "Delete",
      }
  ];

  export const IMPORT_SAMPLE_INVOICE = [
    {
      "accountid": "AC00001",
      "salesno": "IN0000001",
      "item": "Item A",
      "qty": 1,
      "action": "Add",
    },
    {
        "accountid": "AC00001",
        "salesno": "IN0000001",
        "item": "Item A2",
        "qty": 1,
        "action": "Add",
      },
    {
        "accountid": "AC00002",
        "salesno": "IN0000002",
        "item": "Item B",
        "qty": 3,
        "action": "Update",
      },
      {
        "accountid": "AC00003",
        "salesno": "IN0000003",
        "item": "Item C",
        "qty": 2,
        "action": "Delete",
      }
  ];

  export const IMPORT_SAMPLE_CM = [
    {
      "accountid": "AC00001",
      "memono": "CM0000001",
      "item": "Item A",
      "qty": 1,
      "action": "Add",
    },
    {
        "accountid": "AC00001",
        "memono": "CM0000001",
        "item": "Item A2",
        "qty": 1,
        "action": "Add",
      },
    {
        "accountid": "AC00002",
        "memono": "CM0000002",
        "item": "Item B",
        "qty": 3,
        "action": "Update",
      },
      {
        "accountid": "AC00003",
        "memono": "CM0000003",
        "item": "Item C",
        "qty": 2,
        "action": "Delete",
      }
  ];

export const IMPORT_SAMPLE_JOURNAL = [
    // Customer
    {
        tranxId: "TXN00001",
        transactionName: "Transaction 1",
        date: "01/05/2025",
        referenceNumber: "REF00001",
        userType: "Customer",
        accountName: "Account Name 1",
        financeAccountType: "30000 Accounts Receivable Account Name",
        financeAccountGroup: "Accounts Receivable",
        debit: 100,
        credit: 0,
        dueDate: "01/15/2025",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    },
    {
        tranxId: "",
        transactionName: "",
        date: "01/05/2025",
        referenceNumber: "",
        userType: "Customer",
        accountName: "Account Name 1",
        financeAccountType: "70000-8 Sales Account Name",
        financeAccountGroup: "Sales",
        debit: 0,
        credit: 100,
        dueDate: "01/15/2025",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    },
    //Empty row
    {
        tranxId: "",
        transactionName: "",
        date: "",
        referenceNumber: "",
        userType: "",
        accountName: "",
        financeAccountType: "",
        financeAccountGroup: "",
        debit: 0,
        credit: 0,
        dueDate: "",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    },
    // Vendor
    {
        tranxId: "TXN00002",
        transactionName: "Transaction 2",
        date: "02/10/2025",
        referenceNumber: "REF00002",
        userType: "Vendor",
        accountName: "Vendor Name 1",
        financeAccountType: "20000 Accounts Payable Account Name",
        financeAccountGroup: "Accounts Payable",
        debit: 0,
        credit: 200,
        dueDate: "02/20/2025",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    },
    {
        tranxId: "",
        transactionName: "",
        date: "02/10/2025",
        referenceNumber: "",
        userType: "Vendor",
        accountName: "Vendor Name 1",
        financeAccountType: "60000-5 Purchases Account Name",
        financeAccountGroup: "Purchases",
        debit: 200,
        credit: 0,
        dueDate: "02/20/2025",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    },
    //Empty row
    {
        tranxId: "",
        transactionName: "",
        date: "",
        referenceNumber: "",
        userType: "",
        accountName: "",
        financeAccountType: "",
        financeAccountGroup: "",
        debit: 0,
        credit: 0,
        dueDate: "",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    },
    // Employee
    {
        tranxId: "TXN00003",
        transactionName: "Transaction 3",
        date: "03/15/2025",
        referenceNumber: "REF00003",
        userType: "Employee",
        accountName: "Employee Name 1",
        financeAccountType: "50000 Payroll Expense Account Name",
        financeAccountGroup: "Payroll Expense",
        debit: 300,
        credit: 0,
        dueDate: "03/25/2025",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    },
    {
        tranxId: "",
        transactionName: "",
        date: "03/15/2025",
        referenceNumber: "",
        userType: "Employee",
        accountName: "Employee Name 1",
        financeAccountType: "10000 Cash Account Name",
        financeAccountGroup: "Cash",
        debit: 0,
        credit: 300,
        dueDate: "03/25/2025",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    },
    //Empty row
    {
        tranxId: "",
        transactionName: "",
        date: "",
        referenceNumber: "",
        userType: "",
        accountName: "",
        financeAccountType: "",
        financeAccountGroup: "",
        debit: 0,
        credit: 0,
        dueDate: "",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    },
    // Other
    {
        tranxId: "TXN00004",
        transactionName: "Transaction 4",
        date: "04/20/2025",
        referenceNumber: "REF00004",
        userType: "Other",
        accountName: "Other Name 1",
        financeAccountType: "80000 Miscellaneous Expense Account Name",
        financeAccountGroup: "Miscellaneous Expense",
        debit: 400,
        credit: 0,
        dueDate: "04/30/2025",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    },
    {
        tranxId: "",
        transactionName: "",
        date: "04/20/2025",
        referenceNumber: "",
        userType: "Other",
        accountName: "Other Name 1",
        financeAccountType: "10000 Cash Account Name",
        financeAccountGroup: "Cash",
        debit: 0,
        credit: 400,
        dueDate: "04/30/2025",
        memo: "",
        linememo: "",
        postingPeriod: "",
        class: "",
        docNumber: ""
    }
]
